import PageShell, { PageHeader } from "@/components/PageShell";
import Seo from "@/components/Seo";

const tutorials = [
  { id: "install-roku",    title: "Install Nema TV on Roku",         body: "Two-minute walkthrough to add the channel and sign in." },
  { id: "install-firetv",  title: "Install Nema TV on Fire TV",      body: "Side-by-side steps for Fire TV Stick and Cube." },
  { id: "install-android", title: "Install on Android phone / tablet", body: "From download to first stream, with tips on data mode." },
  { id: "install-ios",     title: "Install on iPhone / iPad",        body: "Universal app for iOS with AirPlay support." },
  { id: "dvr",             title: "Using the 3-day DVR",             body: "Pause, rewind and catch up on selected channels." },
  { id: "quality",         title: "Getting the best picture quality", body: "Which settings matter and which are safe to ignore." },
];

const Card = ({ t }) => (
  <div
    data-testid={`tutorial-card-${t.id}`}
    className="group rounded-2xl border border-white/10 bg-[#0F0A19] overflow-hidden hover:border-white/20 hover:-translate-y-1 transition-all duration-500"
  >
    <div className="relative aspect-video overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#6B21D9] via-[#4F0FBF] to-[#22D3EE] opacity-90" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-14 h-14 rounded-full bg-black/40 backdrop-blur-md border border-white/25 flex items-center justify-center">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z" /></svg>
        </div>
      </div>
      <div className="absolute bottom-3 left-3 rounded-full bg-black/40 border border-white/15 backdrop-blur px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] text-white/80">
        Video
      </div>
    </div>
    <div className="p-5">
      <div className="font-display text-lg font-semibold text-white">{t.title}</div>
      <div className="mt-2 text-sm text-white/55">{t.body}</div>
    </div>
  </div>
);

const TutorialsPage = () => (
  <PageShell>
    <Seo
      title="Tutorials — Nema TV"
      description="Step-by-step video guides for installing and getting the best out of Nema TV on every device."
      path="/tutorials"
      schemas={[{
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: tutorials.map((t, i) => ({
          "@type": "ListItem", position: i + 1, name: t.title,
        })),
      }]}
    />
    <PageHeader
      eyebrow="Tutorials"
      title="Get set up in minutes."
      subtitle="Short, focused videos for every device Nema TV supports."
    />
    <div className="max-w-6xl mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {tutorials.map((t) => <Card key={t.id} t={t} />)}
      </div>
      <p className="mt-8 text-xs text-white/40">
        Video walkthroughs are being produced — placeholders shown for now.
      </p>
    </div>
  </PageShell>
);

export default TutorialsPage;
